import { useQuery } from '@apollo/client';

import { EventProduct, getCompletedCateringEventDetails } from '@/api';

import { CateringEventVendorDetailsCompleted } from '../types';
import { parseEventVendorIds } from '../helpers';

type UseCateringCompletedEvent = {
  event: CateringEventVendorDetailsCompleted | undefined;
  loading: boolean;
};

// The route param can carry several ids for aggregated delivery cards, so the
// query takes a list. CATERING events are not aggregated, hence the first result.
export const useCateringCompletedEvent = (id: string): UseCateringCompletedEvent => {
  const { data, loading } = useQuery(getCompletedCateringEventDetails, {
    variables: { input: { eventVendorIds: parseEventVendorIds(id), productType: EventProduct.CATERING } },
  });

  return {
    event: data?.getEventVendors?.eventVendors?.[0] as CateringEventVendorDetailsCompleted | undefined,
    loading,
  };
};
